"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isError(entry) {
    return 'error' in entry;
}
exports.isError = isError;
